import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { I18n } from "./helpers";
import { BrowserRouter } from "react-router-dom";
import { store } from "./store";
import { Provider } from "react-redux";

import { PersistGate } from "redux-persist/integration/react";
import { persistStore } from "redux-persist";

import "./styles/App.css";
import "./styles/imgZoom.css";
import { HelmetProvider } from "react-helmet-async";
import "react-toastify/dist/ReactToastify.css";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import Modals from "./components/Modals"
import NetworkStatus from "./components/networkStatus";

const stripe = loadStripe(
  "pk_test_51O2KfZF0IFIB0WTjFZtPzi3zK4nfczqnVgkEQUwJJ3hZeveEdc8kM6Gm1hA4HvZ4sRHubTx5OPc1k6wXRYlVCnq500Y9yzU2JB"
);

I18n();

const root = ReactDOM.createRoot(document.getElementById("root"));
let persistor = persistStore(store);
const helmetContext = {};



root.render(
  <React.Fragment>
    <BrowserRouter>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <HelmetProvider context={helmetContext}>
            <Elements stripe={stripe}>
              <App />
              <Modals />
              <NetworkStatus />
            </Elements>
          </HelmetProvider>
        </PersistGate>
      </Provider>
    </BrowserRouter>
  </React.Fragment>
);
